import React from "react";
import { noDealsvg } from "../../DealsAndDiscounts/Components/ProductListing/svg";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ZeroOrders = function ZeroOrders(_ref) {
  var orderStatus = _ref.orderStatus,
    orders = _ref.orders,
    loadingOrders = _ref.loadingOrders;
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx("div", {
      className: "mt-4 px-4 lg:px-0",
      children: /*#__PURE__*/_jsx("div", {
        className: "w-full pl-0 xl:pl-6 mt-4 border border-gray-300 rounded-xl",
        children: /*#__PURE__*/_jsxs("div", {
          className: "flex flex-row items-center justify-center p-7 gap-5",
          children: [/*#__PURE__*/_jsx("div", {
            className: "mt-1 lg:mt-0",
            children: noDealsvg
          }), /*#__PURE__*/_jsxs("div", {
            className: "flex flex-col",
            children: [/*#__PURE__*/_jsx("p", {
              className: "text-2xl font-bold",
              children: "Oops!"
            }), /*#__PURE__*/_jsx("p", {
              className: "whitespace-nowrap mt-2",
              children: "No Orders found"
            }), (orders === null || orders === void 0 ? void 0 : orders.length) === 0 && !loadingOrders && orderStatus !== 'Shipped' && orderStatus !== 'Delivered' ? /*#__PURE__*/_jsx("p", {
              className: "xl:whitespace-nowrap mt-1 text-gray-400",
              children: "You haven\u2019t made any purchases yet. Claim your rewards to start shopping and enjoy exclusive offers!"
            }) : /*#__PURE__*/_jsx("p", {
              className: "xl:whitespace-nowrap mt-1 text-gray-400",
              children: "No orders have reached this stage yet. Once your orders are shipped or delivered, you'll see them here!"
            })]
          })]
        })
      })
    })
  });
};
export default ZeroOrders;